import { useAuthedUser } from '../../../../common/providers/AuthedUserProvider';
import { BackgroundSequence } from '../../../../investment-profile/components/BackgroundSequence';
import { exitToFinancialProfile } from '../../../../investment-profile/navigation';

export default function BackgroundProfilePage() {
    const user = useAuthedUser();
    return (
        <BackgroundSequence
            userId={user.id}
            onBack={exitToFinancialProfile}
            onCompleteSubmit={exitToFinancialProfile}
        />
    );
}
